module.exports = __webpack_public_path__ + "img/robot.07db08b3.png";